/**
 * 公開記事の HTML／Markdown 本文に挿入し、中盤に App Store 誘導ブロックを差し込むマーカー。
 * 編集者はこの1行を希望位置に貼り付ける（大文字小文字は区別しない）。
 */
export const ARTICLE_MID_CTA_MARKER = '<!-- SOCIAL_TRIP_MID_CTA -->';

const MID_CTA_MARKER_REGEX = /<!--\s*SOCIAL_TRIP_MID_CTA\s*-->/i;

export type SplitBodyAtMidCtaResult = {
  before: string;
  after: string;
  hasMid: boolean;
};

/**
 * 先頭に一致するマーカー1か所だけで分割する。2個目以降のマーカーは after 側に残る（HTMLコメントとして非表示）。
 */
export function splitBodyAtMidCta(raw: string): SplitBodyAtMidCtaResult {
  if (!raw) {
    return { before: '', after: '', hasMid: false };
  }
  const match = MID_CTA_MARKER_REGEX.exec(raw);
  if (!match || match.index === undefined) {
    return { before: raw, after: '', hasMid: false };
  }
  const idx = match.index;
  const len = match[0].length;
  const before = raw.slice(0, idx).replace(/\s*$/u, '');
  const after = raw.slice(idx + len).replace(/^\s*/u, '');
  return { before, after, hasMid: true };
}
